// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-slideshow-zoom-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-zoom-wrapper .zoom-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n}\n\n.react-slideshow-zoom-wrapper .zoom-wrapper > div {\n  position: relative;\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
